'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
                                                                                                                                                                                                                                                                   * Package Import
                                                                                                                                                                                                                                                                   */


var _browser = require('@sentry/browser');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 * Local Import
 */

/*
 * Code
 */
var identity = function identity(stuff) {
  return stuff;
};
var getUndefined = function getUndefined() {};
var filter = function filter() {
  return true;
};
var getType = function getType(action) {
  return action.type;
};

/*
 * Logger Middleware
 */

exports.default = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$breadcrumbDa = options.breadcrumbDataFromAction,
      breadcrumbDataFromAction = _options$breadcrumbDa === undefined ? getUndefined : _options$breadcrumbDa,
      _options$breadcrumbMe = options.breadcrumbMessageFromAction,
      breadcrumbMessageFromAction = _options$breadcrumbMe === undefined ? getType : _options$breadcrumbMe,
      _options$actionTransf = options.actionTransformer,
      actionTransformer = _options$actionTransf === undefined ? identity : _options$actionTransf,
      _options$stateTransfo = options.stateTransformer,
      stateTransformer = _options$stateTransfo === undefined ? identity : _options$stateTransfo,
      _options$breadcrumbCa = options.breadcrumbCategory,
      breadcrumbCategory = _options$breadcrumbCa === undefined ? 'redux-action' : _options$breadcrumbCa,
      _options$filterBreadc = options.filterBreadcrumbActions,
      filterBreadcrumbActions = _options$filterBreadc === undefined ? filter : _options$filterBreadc,
      getUserContext = options.getUserContext,
      getTags = options.getTags;


  return function (store) {
    var lastAction = void 0;

    (0, _browser.configureScope)(function (scope) {
      scope.addEventProcessor(function (event, hint) {
        var state = store.getState();

        event.extra = _extends({}, event.extra, {
          lastAction: actionTransformer(lastAction),
          state: stateTransformer(state)
        });

        if (getUserContext) {
          event.user = _extends({}, event.user, getUserContext(state));
        }
        if (getTags) {
          var tags = getTags(state);
          Object.keys(tags).forEach(function (key) {
            event.tags = _extends({}, event.tags, _defineProperty({}, key, tags[key]));
          });
        }
        return event;
      });
    });

    return function (next) {
      return function (action) {
        if (filterBreadcrumbActions(action)) {
          (0, _browser.addBreadcrumb)({
            category: breadcrumbCategory,
            message: breadcrumbMessageFromAction(action),
            level: 'info',
            data: breadcrumbDataFromAction(action)
          });
        }

        lastAction = action;
        return next(action);
      };
    };
  };
};